import React from 'react';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import cx from 'classnames';

import type { WCategoryView, WShopSearchEntityView } from '@zola/svc-web-api-ts-client';
import ProductTilesContainer from '../../../../components/common/shop/ProductTile/ProductTilesContainer';

type ProductsProps = {
  activeCategoryKey: string;
  categoryFilter: WCategoryView[];
  eventData: {
    location?: string;
    section?: string;
  };
  firstPage: number;
  handleLoadPreviousProducts: () => void;
  handleMarketingModulesRedirect: (index: number) => void;
  handleTileSelect: (index: number) => void;
  hasCategoryLink: boolean;
  hasTopProductsLoading: boolean;
  isRectangularImage: boolean;
  marketingModules: MarketingModuleLookup | null;
  metaData?: {
    title?: string;
  };
  products: WShopSearchEntityView[];
  shopEventData: Record<string, unknown>;
  transactionIdsMap: Record<number, unknown>;
  useGridTiles?: boolean;
};

export const Products = ({
  activeCategoryKey,
  categoryFilter,
  eventData,
  firstPage,
  handleLoadPreviousProducts,
  handleMarketingModulesRedirect,
  handleTileSelect,
  hasCategoryLink,
  hasTopProductsLoading,
  isRectangularImage,
  marketingModules,
  metaData,
  products,
  shopEventData,
  transactionIdsMap,
  useGridTiles,
}: ProductsProps) => {
  const data = { ...eventData, ...shopEventData };
  // for cases when previous pages are not loaded - start index with possible offset
  const startIndex = firstPage * 24;
  const tileWrapperCssClass = useGridTiles
    ? 'zola-product-tile-wrapper'
    : 'col-xs-6 col-sm-4 col-md-4 col-lg-3 col-xl-3';

  return (
    <>
      {firstPage > 0 && (
        <div className="shop-load-previous">
          {!hasTopProductsLoading && (
            <ButtonV2 variant="secondary" onClick={handleLoadPreviousProducts}>
              Load Previous
            </ButtonV2>
          )}
          {hasTopProductsLoading && (
            <div className="shop-paging-loader">
              <div className="busy-loader" />
            </div>
          )}
        </div>
      )}
      <div className={cx('zola-product-tiles', { row: !useGridTiles })}>
        {products && products.length > 0 && (
          <ProductTilesContainer
            /** @ts-expect-error inferred types for ProductTilesContainer are not correct */
            tileWrapperCssClass={tileWrapperCssClass}
            isRectangularImage={isRectangularImage}
            hasCategoryLink={hasCategoryLink}
            eventData={data}
            startIndex={startIndex}
            products={products}
            onPdpRedirect={handleTileSelect}
            categoryTreeList={categoryFilter}
            activeCategoryKey={activeCategoryKey}
            metaData={metaData}
            transactionIdsMap={transactionIdsMap}
            marketingModules={marketingModules}
            marketingModulesCallback={handleMarketingModulesRedirect}
            useGridVersion={useGridTiles}
          />
        )}
      </div>
    </>
  );
};
